import { resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f5c7756"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forward-geocoding-input-row" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "forward-geocoding-container",
    style: _normalizeStyle(_ctx.cssStyles)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_v_text_field, {
        modelValue: _ctx.searchText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
        class: _normalizeClass(['forward-geocoding-input', _ctx.locationJustUpdated ? 'geocode-success' : '', _ctx.small ? 'forward-geocoding-input-small' : '']),
        label: _ctx.locationJustUpdated ? 'Location Updated' : 'Enter a location',
        "bg-color": "black",
        density: "compact",
        "hide-details": "",
        variant: "solo",
        color: _ctx.accentColor,
        onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        onKeyup: [
          _cache[2] || (_cache[2] = _withKeys(() => _ctx.performForwardGeocodingSearch(), ["enter"])),
          _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.searchResults = null), ["esc"]))
        ],
        "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchResults = null)),
        "error-messages": _ctx.searchErrorMessage
      }, null, 8, ["modelValue", "class", "label", "color", "error-messages"]), [
        [_vShow, _ctx.searchOpen]
      ]),
      _createVNode(_component_font_awesome_icon, {
        class: "geocoding-search-icon",
        icon: "magnifying-glass",
        size: _ctx.searchOpen ? 'xl' : _ctx.buttonSize,
        color: !_ctx.searchOpen || (_ctx.searchText && _ctx.searchText.length > 2) ? _ctx.accentColor : 'gray',
        onClick: _cache[5] || (_cache[5] = () => {
          if (_ctx.searchOpen) {
            _ctx.performForwardGeocodingSearch();
          } else {
            _ctx.searchOpen = true;
          }
        })
      }, null, 8, ["size", "color"]),
      _renderSlot(_ctx.$slots, "append-icon", { class: "geocode-icon" }, undefined, true),
      _withDirectives(_createVNode(_component_font_awesome_icon, {
        class: "geocoding-close-icon",
        icon: "circle-xmark",
        size: _ctx.searchOpen ? 'xl' : '1x',
        color: "gray",
        onClick: _cache[6] || (_cache[6] = () => {
          _ctx.searchOpen = false;
          _ctx.clearSearchData();
        })
      }, null, 8, ["size"]), [
        [_vShow, _ctx.searchOpen && !_ctx.stayOpen]
      ])
    ]),
    (_ctx.searchResults !== null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["forward-geocoding-results", [_ctx.small ? 'results-small' : '']])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.searchResults !== null ?  _ctx.searchResults.features : []), (feature, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "forward-geocoding-result",
              key: index,
              onClick: () => _ctx.setLocationFromSearchFeature(feature)
            }, _toDisplayString(feature.place_name), 9, _hoisted_2))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 4))
}